module.exports = __webpack_public_path__ + "static/media/visita.ff05dc4d.png";